<div style="display: flex;flex-direction: row; align-content: space-between; " mat-ripple>
  @if (this.Player) {
    <div style="font-size: 16px; margin-right: 5px;;">
      {{this.Player.JerseyNo}}
    </div>
  }
  @if (this.Player) {
    <div (click)="navigate(this.Player.PlayerId)">
      <span style="font-size: 10px;">{{this.Player.PlayerLastName}}</span>
      <br/>
      <!-- <span style="font-size: 10px">{{this.Player[0].PlayerFirstName}}</span><br/> -->
      <!-- add tags-->
    </div>
  }

</div>